import { invalidateMinicart } from "~/app/store/bffApi";
import { occFetch, occUrl } from "~/app/api/occ/occFetch";
import type {
  AddToCartApiItem,
  AddToCartResponseItem,
  AddToCartResultListDTO,
} from "~/features/cart/cart/api/AddToCart";

export interface QuoteCheckoutDTO {
  quoteNumber: string;
  items: AddToCartApiItem[];
}

interface QuoteToCartResponse {
  ok: boolean;
  responseItems: AddToCartResponseItem[];
}

export function sendData(data: QuoteCheckoutDTO): Promise<QuoteToCartResponse> {
  return occFetch(occUrl("/quote/checkout"), {
    body: JSON.stringify(data),
    method: "POST",
    headers: { "Content-Type": "application/json" },
  }).then(async (result) => {
    invalidateMinicart();
    const responseBody: AddToCartResultListDTO | undefined = result.ok ? await result.json() : undefined;
    return {
      ok: result.ok,
      responseItems: responseBody?.items ?? [],
    };
  });
}
